export const primitiveColor = {
  hatoPrimary100: '#e6f8ff',
  hatoPrimary200: '#a3e3ff',
  hatoPrimary300: '#7ad3ff',
  hatoPrimary400: '#52bfff',
  hatoPrimary500: '#29a9ff',
  hatoPrimary600: '#0092ff',
  hatoPrimary700: '#0958d9',
  hatoPrimary800: '#003eb3',
  hatoPrimary900: '#002c8c',
  hatoPrimary950: '#001d66',
  hatoSecondary100: '#98aace',
  hatoSecondary200: '#7089ba',
  hatoSecondary300: '#4f6fac',
  hatoSecondary400: '#2957a0',
  hatoSecondary500: '#224f97',
  hatoSecondary600: '#17468b',
  hatoSecondary700: '#0d3c7f',
  hatoSecondary800: '#002b68',
  hatoSecondary900: '#001a45',
  hatoSecondary950: '#000b1f',
  hatoTertiary100: '#fff9f0',
  hatoTertiary200: '#fff8f0',
  hatoTertiary300: '#ffedd9',
  hatoTertiary400: '#f7d1ab',
  hatoTertiary500: '#ebb07c',
  hatoTertiary600: '#de8e52',
  hatoTertiary700: '#b86d3b',
  hatoTertiary800: '#914e27',
  hatoTertiary900: '#6b3318',
  hatoTertiary950: '#451f0e',
  hatoAlternative100: '#f1e6ff',
  hatoAlternative200: '#d5b8ff',
  hatoAlternative300: '#b88dfc',
  hatoAlternative400: '#9260f0',
  hatoAlternative500: '#6d36e3',
  hatoAlternative600: '#4711d5',
  hatoAlternative700: '#3005b0',
  hatoAlternative800: '#1e008a',
  hatoAlternative900: '#120063',
  hatoAlternative950: '#09003d',
  red100: '#fff1f0',
  red200: '#ffccc7',
  red300: '#ffa39e',
  red400: '#ff7875',
  red500: '#ff4d4f',
  red600: '#f5222d',
  red700: '#cf1322',
  red800: '#a8071a',
  red900: '#820014',
  red950: '#5c0011',
  blue100: '#e6f7ff',
  blue200: '#bae7ff',
  blue300: '#91d5ff',
  blue400: '#69c0ff',
  blue500: '#40a9ff',
  blue600: '#1890ff',
  blue700: '#096dd9',
  blue800: '#0050b3',
  blue900: '#003a8c',
  blue950: '#002766',
  gray000: '#ffffff',
  gray100: '#fafafa',
  gray200: '#f5f5f5',
  gray300: '#f0f0f0',
  gray400: '#d9d9d9',
  gray500: '#bfbfbf',
  gray600: '#8c8c8c',
  gray700: '#595959',
  gray800: '#434343',
  gray900: '#262626',
  gray950: '#000000',
  orange100: '#fff7e6',
  orange200: '#ffe7ba',
  orange300: '#ffd591',
  orange400: '#ffc069',
  orange500: '#ffa940',
  orange600: '#fa8c16',
  orange700: '#d46b08',
  orange800: '#ad4e00',
  orange900: '#873800',
  orange950: '#612500',
  volcano100: '#fff2e8',
  volcano200: '#ffd8bf',
  volcano300: '#ffbb96',
  volcano400: '#ff9c6e',
  volcano500: '#ff7a45',
  volcano600: '#fa541c',
  volcano700: '#d4380d',
  volcano800: '#ad2102',
  volcano900: '#871400',
  volcano950: '#610b00',
  gold100: '#fffbe6',
  gold200: '#fff1b8',
  gold300: '#ffe58f',
  gold400: '#ffd666',
  gold500: '#ffc53d',
  gold600: '#faad14',
  gold700: '#d48806',
  gold800: '#ad6800',
  gold900: '#874d00',
  gold950: '#613400',
  yellow100: '#feffe6',
  yellow200: '#ffffb8',
  yellow300: '#fffb8f',
  yellow400: '#fff566',
  yellow500: '#ffec3d',
  yellow600: '#fadb14',
  yellow700: '#d4b106',
  yellow800: '#ad8b00',
  yellow900: '#876800',
  yellow950: '#614700',
  lime100: '#fcffe6',
  lime200: '#f4ffb8',
  lime300: '#eaff8f',
  lime400: '#d3f261',
  lime500: '#bae637',
  lime600: '#a0d911',
  lime700: '#7cb305',
  lime800: '#5b8c00',
  lime900: '#3f6600',
  lime950: '#254000',
  green100: '#f6ffed',
  green200: '#d9f7be',
  green300: '#b7eb8f',
  green400: '#95de64',
  green500: '#73d13d',
  green600: '#52c41a',
  green700: '#389e0d',
  green800: '#237804',
  green900: '#135200',
  green950: '#092b00',
  cyan100: '#e6fffb',
  cyan200: '#b5f5ec',
  cyan300: '#87e8de',
  cyan400: '#5cdbd3',
  cyan500: '#36cfc9',
  cyan600: '#13c2c2',
  cyan700: '#08979c',
  cyan800: '#006d75',
  cyan900: '#00474f',
  cyan950: '#002329',
  geekblue100: '#f0f5ff',
  geekblue200: '#d6e4ff',
  geekblue300: '#adc6ff',
  geekblue400: '#85a5ff',
  geekblue500: '#597ef7',
  geekblue600: '#2f54eb',
  geekblue700: '#1d39c4',
  geekblue800: '#10239e',
  geekblue900: '#061178',
  geekblue950: '#030852',
  purple100: '#f9f0ff',
  purple200: '#efdbff',
  purple300: '#d3adf7',
  purple400: '#b37feb',
  purple500: '#9254de',
  purple600: '#722ed1',
  purple700: '#531dab',
  purple800: '#391085',
  purple900: '#22075e',
  purple950: '#120338',
  magenta100: '#fff0f6',
  magenta200: '#ffd6e7',
  magenta300: '#ffadd2',
  magenta400: '#ff85c0',
  magenta500: '#f759ab',
  magenta600: '#eb2f96',
  magenta700: '#c41d7f',
  magenta800: '#9e1068',
  magenta900: '#780650',
  magenta950: '#520339',
  opacity100: '#0000001a',
  opacity200: '#00000033',
  opacity300: '#0000004d',
  opacity400: '#00000066',
  opacity500: '#00000080',
  opacity600: '#00000099',
  opacity700: '#000000b3',
  opacity800: '#000000cc',
  opacity900: '#000000e6',
  opacity150: '#00000026',
}

export type PrimitiveColorTokens = {
  [K in keyof typeof primitiveColor]: string
}
export type PrimitiveColorKeys = keyof typeof primitiveColor
